import { useQuery, ApolloQueryResult } from "@apollo/client"
import { RentalTerminalVariant, Product } from "../components/interfaces/SaleorTypes"
import { client } from "../graphql-saleor/client"
import { GET_RENTAL_TERMINAL } from "../graphql-saleor/queries/getRentalTerminalQuery"
import {
  SELECTED_CHANNEL_SLUG,
  PRODUCT_RENTAL_TERMINAL_SLUG,
  RENTAL_INITIAL_COST_SLUG,
  RENTAL_MONTHLY_COST_SLUG,
} from "../utils/saleor-constants"

export const useRentalTerminalQuery = () => {
  const { data, error, loading, refetch } = useQuery(GET_RENTAL_TERMINAL, {
    client: client,
    variables: {
      channelSlug: SELECTED_CHANNEL_SLUG,
      productSlug: PRODUCT_RENTAL_TERMINAL_SLUG,
    },
  })
  return {
    rentalTerminal: data?.product as Product | undefined,
    initialCostProduct: data?.product?.variants?.find(
      (variant: RentalTerminalVariant) => variant?.rentalVariantSlug === RENTAL_INITIAL_COST_SLUG,
    ) as RentalTerminalVariant | undefined,
    monthlyCostProduct: data?.product?.variants?.find(
      (variant: RentalTerminalVariant) => variant?.rentalVariantSlug === RENTAL_MONTHLY_COST_SLUG,
    ) as RentalTerminalVariant | undefined,
    error,
    loading,
    refetch,
  }
}
